import React from 'react';

import { CloseAction, type CloseActionProps } from '../../../actions';

import { Wrapper } from './FixedCloseAction.style';

export interface FixedCloseActionProps {
    ariaLabel?: CloseActionProps['ariaLabel'];
    back?: CloseActionProps['back'];
    disabled?: CloseActionProps['disabled'];
    onAction?: CloseActionProps['onAction'];
}

// TODO: We need to update all instances of `<Button* />`
// within `Sheet` to use this newer action style.
export function FixedCloseAction({ ariaLabel, back = false, disabled = false, onAction }: FixedCloseActionProps) {
    return (
        <Wrapper $back={back}>
            <CloseAction aria-label={ariaLabel} back={back} disabled={disabled} onAction={onAction} />
        </Wrapper>
    );
}
